export const transfersConstants = {
  "discardTitle": "Discard Transfer",
  "discardMessage": "The response will be removed from the Transfers tab. Click 'Confirm' to discard the Transfer."
};
export const language_info = "Language Finesse";
export const language_info_description = (
  <>
    Click 'Select Text', highlight the text on the slide
    <br />
    and then click 'Proceed' to finesse language
  </>
);
export const discard_popup_header = "Discard Selected Text";
export const discard_popup_body =
  "The selected text and Language finesse options applied will be discarded from the Language tab. Click ‘Confirm’ to apply.";
export const replace_popup_header = "Replace Selected Text";
export const replace_popup_body =
  "The selected text will be replaced on the slide and the suggestion will be removed from the Language tab. Click ‘Confirm’ to apply.";
export const ai_warning =
  "AI generated output may contain inaccuracies or errors. Verify output before use.";
export const dummy_text =
  "The integration of AI systems enhances efficiency, accuracy, and productivity in multiple fields. It facilitates advanced data analysis, automates routine tasks, and drives innovation, leading to significant improvements in business operations and customer experiences.";
export const dummy_text2 =
  "Artificial Intelligence (AI) offers a wide range of benefits across various industries and applications. Automation: AI can automate repetitive and time-consuming tasks, leading to increased efficiency and productivity.";
export const tooltipReplace = "Select text to replace";

export const improveWrittenLanguage = "Improve written language";
export const concise = "Make more concise";
export const translate = "Translate";

export const reviewConstants = {
  "featureTitle": "Template Wording",
  "featureSubTitle": "Find template wording relevant to your slides",
  "loadingMessage": "Identifying Template Wording...",
  "noResultsTitle": "Find Template Wording",
  "noResultsSubTitle": "Click 'Identify' to begin slide review",
  "btnIdentifyLabel": "Identify",
  "btnRefreshLabel": "Refresh",
  "btnDiscardAllLabel": "Discard All",
  "btnDiscardLabel": "Discard",
  "btnInsertLabel": "Insert",
  "discardAllTitle": "Discard All Template Wording",
  "discardAllMessage": "All results will be removed from Template Wording. Click 'Confirm' to discard all results.",
  "discardTitle": "Discard Template Wording",
  "discardMessage": "This result will be removed from Template Wording. Click 'Confirm' to discard the result.",
  "discardAllToastMessage": "All Template Wording discarded successfully",
  "discardToastMessage": "Template Wording discarded successfully",
  "noTempWordFound": "No relevant template wording found"
};